import { MediaFileConnectionType } from "@next-platform/packages-ts-types";

import { ROUTES } from "@/constants";

export type MediaFileLinkTarget = {
  readonly type: MediaFileConnectionType;
  readonly id: string;
  /** Set on a conversation image, so its link opens that chat instead of the chatbot's page. */
  readonly conversationId?: string;
};

/** Where a related entity's link goes: the chat an image came from, the chatbot, the persona or the profile. */
export default function getMediaFileConnectionPath({ type, id, conversationId }: MediaFileLinkTarget): string {
  switch (type) {
    case MediaFileConnectionType.PERSONA:
      return `${ROUTES.personaEdit}/${encodeURIComponent(id)}`;
    case MediaFileConnectionType.USER:
      // The gallery only lists the viewer's own files, so a user avatar is always their own profile.
      return ROUTES.profile;
    default:
      return conversationId
        ? `${ROUTES.chat}/${encodeURIComponent(id)}/${encodeURIComponent(conversationId)}`
        : `${ROUTES.chatbot}/${encodeURIComponent(id)}`;
  }
}
